import { t } from '@lingui/core/macro';

export const contactTypeOptions = [
  { value: 'corporate', label: t`Corporate` },
  { value: 'facility', label: t`Facility` },
];

export const decisionMakerOptions = [
  { value: 'decision_maker', label: t`Decision Maker` },
  { value: 'decision_influencer', label: t`Decision Influencer` },
  { value: 'technical_expert', label: t`Technical Expert` },
];

export const facilityTypeOptions = [
  { value: 'headquarters', label: t`Headquarters` },
  { value: 'distribution_center', label: t`Distribution Center` },
  { value: 'manufacturing', label: t`Manufacturing` },
  { value: 'cold_storage', label: t`Cold Storage` },
  { value: 'warehouse', label: t`Warehouse` },
  { value: 'other', label: t`Other` },
];

export const vehicleTypeOptions = [
  { value: 'order_stock_picker', label: t`Order-Stock Picker` },
  { value: 'pallet_truck', label: t`Pallet Truck` },
  { value: 'reach_truck', label: t`Reach Truck` },
  { value: 'sit_down_counterbalanced', label: t`Sit-Down Counterbalanced` },
  { value: 'stand_up_counterbalanced', label: t`Stand-Up Counterbalanced` },
  { value: 'tow_tractor', label: t`Tow Tractor` },
  { value: 'turret_truck', label: t`Turret Truck` },
  { value: 'walkie_stacker', label: t`Walkie Stacker` },
  { value: 'other', label: t`Other` },
];

export const vehicleMakeOptions = [
  { value: 'advance', label: t`Advance` },
  { value: 'a_g_mercury', label: t`AG Mercury` },
  { value: 'aisle_master', label: t`Aisle Master` },
  { value: 'auto_guide', label: t`AutoGuide` },
  { value: 'barrett', label: t`Barrett` },
  { value: 'bendi_landoll', label: t`Bendi/Landoll` },
  { value: 'big_joe', label: t`Big Joe` },
  { value: 'blue_giant', label: t`Blue Giant` },
  { value: 'b_t_prime_mover', label: t`BT Prime Mover` },
  { value: 'caterpillar', label: t`Caterpillar` },
  { value: 'clark', label: t`Clark` },
  { value: 'crown', label: t`Crown` },
  { value: 'dockstocker', label: t`Dockstocker` },
  { value: 'doosan_daewoo', label: t`Doosan/Daewoo` },
  { value: 'drexel', label: t`Drexel` },
  { value: 'elwell_parker', label: t`Elwell-Parker` },
  { value: 'flexi', label: t`Flexi` },
  { value: 'gregory', label: t`Gregory` },
  { value: 'heli', label: t`Heli` },
  { value: 'hoist', label: t`Hoist` },
  { value: 'hubtex', label: t`Hubtex` },
  { value: 'hyster', label: t`Hyster` },
  { value: 'hyundai', label: t`Hyundai` },
  { value: 'jungheinrich', label: t`Jungheinrich` },
  { value: 'kalmar', label: t`Kalmar` },
  { value: 'komatsu', label: t`Komatsu` },
  { value: 'linde', label: t`Linde` },
  { value: 'lift_a_lot', label: t`Lift-a-Lot` },
  { value: 'mariotti', label: t`Mariotti` },
  { value: 'mitsubishi', label: t`Mitsubishi` },
  { value: 'motrec', label: t`Motrec` },
  { value: 'multiton', label: t`Multiton` },
  { value: 'nissan', label: t`Nissan` },
  { value: 'raymond', label: t`Raymond` },
  { value: 'rico', label: t`Rico` },
  { value: 'royal', label: t`Royal` },
  { value: 'savant-automation', label: t`Savant Automation` },
  { value: 'schaeff', label: t`Schaeff` },
  { value: 'schreck', label: t`Schreck` },
  { value: 'sroka', label: t`Sroka` },
  { value: 'steinbock', label: t`Steinbock` },
  { value: 'taylor_dunn', label: t`Taylor-Dunn` },
  { value: 't_c_m', label: t`TCM` },
  { value: 'toyota', label: t`Toyota` },
  { value: 'yale', label: t`Yale` },
  { value: 'tusk', label: t`Tusk` },
  { value: 'uni-carrier', label: t`UniCarrier` },
  { value: 'white', label: t`White` },
  { value: 'world', label: t`World` },
  { value: 'other', label: t`Other` },
];

export const vehicleVoltageOptions = [
  { value: 24, label: '24V' },
  { value: 36, label: '36V' },
  { value: 48, label: '48V' },
  { value: 72, label: '72V' },
  { value: 80, label: '80V' },
  { value: 96, label: '96V' },
];

export const batteryManufacturerOptions = [
  { value: 'battery_builders', label: t`Battery Builders` },
  { value: 'bulldog', label: t`Bulldog` },
  { value: 'crown', label: t`Crown` },
  { value: 'deka', label: t`Deka` },
  { value: 'douglas', label: t`Douglas` },
  { value: 'enersys', label: t`EnerSys` },
  { value: 'gnb', label: t`Stryten` },
  { value: 'hawker', label: t`Hawker` },
  { value: 'hoppecke', label: t`Hoppecke` },
  { value: 'other', label: t`Other` },
];

export const competitorBatteryManufacturerOptions = [
  { value: 'battery_builders', label: t`Battery Builders` },
  { value: 'bulldog', label: t`Bulldog` },
  { value: 'crown', label: t`Crown` },
  { value: 'deka', label: t`Deka` },
  { value: 'douglas', label: t`Douglas` },
  { value: 'enersys', label: t`EnerSys` },
  { value: 'hawker', label: t`Hawker` },
  { value: 'hoppecke', label: t`Hoppecke` },
  { value: 'other', label: t`Other` },
];

export const chargerManufacturerOptions = [
  { value: 'act', label: t`ACT` },
  { value: 'aes', label: t`AES` },
  { value: 'ametek', label: t`Ametek` },
  { value: 'bassi', label: t`Bassi` },
  { value: 'crown_powerhouse', label: t`Crown PowerHouse` },
  { value: 'crown_v_force', label: t`Crown V-Force` },
  { value: 'douglas', label: t`Douglas` },
  { value: 'ecotec', label: t`Ecotec` },
  { value: 'enatel', label: t`Enatel` },
  { value: 'enersys', label: t`EnerSys` },
  { value: 'geci', label: t`GECI` },
  { value: 'gnb', label: t`Stryten` },
  { value: 'hawker', label: t`Hawker` },
  { value: 'posicharge', label: t`Posicharge` },
  { value: 'power_designers', label: t`Power Designers` },
  { value: 'stanbury', label: t`Stanbury` },
  { value: 'other', label: t`Other` },
];

export const competitorChargerManufacturerOptions = [
  { value: 'act', label: t`ACT` },
  { value: 'aes', label: t`AES` },
  { value: 'ametek', label: t`Ametek` },
  { value: 'bassi', label: t`Bassi` },
  { value: 'crown_powerhouse', label: t`Crown PowerHouse` },
  { value: 'crown_v_force', label: t`Crown V-Force` },
  { value: 'douglas', label: t`Douglas` },
  { value: 'ecotec', label: t`Ecotec` },
  { value: 'enatel', label: t`Enatel` },
  { value: 'enersys', label: t`EnerSys` },
  { value: 'geci', label: t`GECI` },
  { value: 'hawker', label: t`Hawker` },
  { value: 'posicharge', label: t`Posicharge` },
  { value: 'power_designers', label: t`Power Designers` },
  { value: 'stanbury', label: t`Stanbury` },
  { value: 'other', label: t`Other` },
];

export const chargingStrategyOptions = [
  { value: 'fast', label: t`Fast Charge` },
  { value: 'opportunity', label: t`Opportunity Charge` },
  { value: 'conventional', label: t`Conventional Charge` },
  { value: 'lithium', label: t`Lithium` },
];

export const chargingStrategyOptionsShort = [
  { value: 'fast', label: t`Fast` },
  { value: 'opportunity', label: t`Opportunity` },
  { value: 'conventional', label: t`Conventional` },
  { value: 'lithium', label: t`Lithium` },
];

export const chargingStrategyOptionsShortModel = [
  { value: 'opportunity_fast', label: t`Opportunity/Fast` },
  { value: 'conventional', label: t`Conventional` },
  { value: 'lithium', label: t`Lithium` },
];

export const chargingStrategyOptionsShortModelFix = [
  { value: 'opportunity_fast', label: t`Opportunity/Fast` },
  { value: 'conventional', label: t`Conventional` },
  { value: 'lithium', label: t`Lithium` },
  { value: 'opportunity', label: t`Opportunity` },
  { value: 'fast', label: t`Fast` },
];

export const acInputOptions = [
  { value: '208_240_1', label: t`208/240 1ø` },
  { value: '208_240_3', label: t`208/240 3ø` },
  { value: '480_3', label: t`480 3ø` },
  { value: '600_3', label: t`600 3ø` },
];

export const connectorOptions = [
  { value: 175, label: t`SB 175` },
  { value: 350, label: t`SB 350` },
  { value: 320, label: t`Rema 320` },
  { value: 640, label: t`Rema 640` },
];

export const warrantiedDailyLimitOptions = [
  { value: '2_ebu', label: t`2 EBUs / 160%` },
  { value: '1_5_ebu', label: t`1.5 EBUs / 120%` },
];

export const timeZoneOptions = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaskan Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaiian Time (HT)' },
  { value: 'Etc/GMT', label: 'Greenwich Mean Time (GMT)' },
  { value: 'Europe/Paris', label: 'Central European Time (CET)' },
  { value: 'Europe/Kiev', label: 'Eastern European Time (EET)' },
  { value: 'Europe/Moscow', label: 'Moscow Time (MSK)' },
  { value: 'Etc/GMT+1', label: 'GMT-1' },
  { value: 'Etc/GMT+2', label: 'GMT-2' },
  { value: 'Etc/GMT+3', label: 'GMT-3' },
  { value: 'Etc/GMT+4', label: 'GMT-4' },
  { value: 'Etc/GMT+5', label: 'GMT-5' },
  { value: 'Etc/GMT+6', label: 'GMT-6' },
  { value: 'Etc/GMT+7', label: 'GMT-7' },
  { value: 'Etc/GMT+8', label: 'GMT-8' },
  { value: 'Etc/GMT+9', label: 'GMT-9' },
  { value: 'Etc/GMT+10', label: 'GMT-10' },
  { value: 'Etc/GMT+11', label: 'GMT-11' },
  { value: 'Etc/GMT+12', label: 'GMT-12' },
  { value: 'Etc/GMT-1', label: 'GMT+1' },
  { value: 'Etc/GMT-2', label: 'GMT+2' },
  { value: 'Etc/GMT-3', label: 'GMT+3' },
  { value: 'Etc/GMT-4', label: 'GMT+4' },
  { value: 'Etc/GMT-5', label: 'GMT+5' },
  { value: 'Etc/GMT-6', label: 'GMT+6' },
  { value: 'Etc/GMT-7', label: 'GMT+7' },
  { value: 'Etc/GMT-8', label: 'GMT+8' },
  { value: 'Etc/GMT-9', label: 'GMT+9' },
  { value: 'Etc/GMT-10', label: 'GMT+10' },
  { value: 'Etc/GMT-11', label: 'GMT+11' },
  { value: 'Etc/GMT-12', label: 'GMT+12' },
];

export const cableConfigurationOptions = [
  { value: 'single_charge', label: 'Single Charge, Single Discharge' },
  { value: 'dual_charge_single', label: 'Dual Charge, Single Discharge' },
  { value: 'dual_charge_dual', label: 'Dual Charge, Dual Discharge' },
];

export const batteryChemistryOptions = [
  { value: 'flooded_lead_acid', label: t`Flooded Lead Acid` },
  { value: 'sealed_lead_acid', label: t`Sealed Lead Acid` },
  { value: 'lithium', label: t`Lithium` },
];

export const monitorBatteryChemistryOptions = [
  { value: 'lead_acid', label: t`Lead Acid` },
  { value: 'lithium', label: t`Lithium` },
  { value: 'agm', label: t`AGM` },
];

export const addressTypes = [
  { value: 'mail', label: t`mailing` },
  { value: 'shipping', label: t`shipping` },
  { value: 'billing', label: t`billing` },
];

export const taskTypes = [
  { value: 'general', label: t`General Task` },
  { value: 'installation', label: t`Installation Task` },
];
export const fuelConversionMethods = [
  { value: 'gallons_LPG', label: t`Gallons of LPG` },
  { value: 'liters_LPG', label: t`Liters of LPG` },
  { value: 'gallons_diesel', label: t`Gallons of Diesel` },
  { value: 'liters_diesel', label: t`Liters of Diesel` },
  { value: 'cubic_feet_CNG', label: t`1000 Cubic Feet of CNG` },
  { value: 'cubic_meters_CNG', label: t`Cubic Meters of CNG` },
];

export const powerLoggerTypes = [
  { value: 'power_logger_cellular', label: t`Cellular` },
  { value: 'power_logger_bluetooth', label: t`Bluetooth` },
];

export const installationLocations = [
  { value: 'battery_mounted', label: t`Battery Mounted` },
  { value: 'vehicle_mounted', label: t`Vehicle Mounted` },
];

export const solutionTypeOptions = [
  { value: 'battery_change', label: t`Battery Change` },
  { value: 'single_battery', label: t`Single Battery` },
];

export const batteryStrategyTypeOptions = [
  { value: 'multiple_batteries', label: t`Multiple Batteries` },
  { value: 'single_battery', label: t`Single Battery` },
];

export const batterySeriesOptions = {
  battery_builders: [
    { value: 'fplm', label: t`FPLM` },
    { value: 'other', label: t`Other` },
  ],
  bulldog: [
    { value: 'elite_power', label: t`Elite Power` },
    { value: 'bull_pak', label: t`Bull-Pak` },
    { value: 'other', label: t`Other` },
  ],
  crown: [
    { value: 'crown_industrial_batteries', label: t`Crown` },
    { value: 'h2go_low_maintenance', label: t`H2Go Low Maint.` },
    { value: 'max_capacity', label: t`Max Capacity` },
    { value: 'other', label: t`Other` },
  ],
  deka: [
    { value: 'd_series', label: t`D-Series` },
    { value: 'maxpower', label: t`MaxPowr` },
    { value: 'hydrasaver', label: t`HydraSaver` },
    { value: 'fastcharge', label: t`FastCharge` },
    { value: 'dominator', label: t`Dominator` },
    { value: 'maintenancesaver', label: t`MaintenanceSaver` },
    { value: 'chargemate', label: t`Chargemate` },
    { value: 'powrmate', label: t`PowrMate` },
    { value: 'gel_mate', label: t`Gel-Mate` },
    { value: 'ready_power_lion', label: t`Ready Power Li-Ion` },
    { value: 'other', label: t`Other` },
  ],
  douglas: [
    { value: 'legacy_high_performance', label: t`Legacy High Perf.` },
    { value: 'legacy_opportunity_charge', label: t`Legacy Opp Charge` },
    { value: 'legacy_rapid_charge', label: t`Legacy Rapid Charge` },
    { value: 'legacy_low_maintenance', label: t`Legacy Low Maint.` },
    { value: 'legacy_platinum', label: t`Legacy Platinum` },
    { value: 'legacy_arctic', label: t`Legacy Arctic` },
    { value: 'other', label: t`Other` },
  ],
  enersys: [
    { value: 'workhog', label: t`Workhog` },
    { value: 'deserthog', label: t`Deserthog` },
    { value: 'loadhog', label: t`Loadhog` },
    { value: 'superhog', label: t`Superhog` },
    { value: 'smarthog', label: t`Smarthog` },
    { value: 'smartpack', label: t`Smartpack` },
    { value: 'hup', label: t`HUP` },
    { value: 'nexsys_2v_cells', label: t`NexSys 2V Cells` },
    { value: 'nexsys_blocks', label: t`NexSys Blocks` },
    { value: 'other', label: t`Other` },
  ],
  gnb: [{ value: 'other', label: t`Other` }],
  hawker: [
    { value: 'energy_plus', label: t`Energy-Plus` },
    { value: 'envirlink', label: t`Envirolink` },
    { value: 'flexpak', label: t`Flexpak` },
    { value: 'powerline', label: t`Powerline` },
    { value: 'water_less', label: t`Water Less` },
    { value: 'other', label: t`Other` },
  ],
  hoppecke: [
    { value: 'uplift', label: t`Uplift` },
    { value: 'uplift_air', label: t`Uplift Air` },
    { value: 'uplift_save', label: t`Uplift Save` },
    { value: 'other', label: t`Other` },
  ],
  other: [{ value: 'other', label: t`Other` }],
};

export const channelTypeOptions = [
  { value: 'direct_customer', label: t`Direct Customer` },
  { value: 'battery_dealer', label: t`Battery Dealer` },
  { value: 'truck_dealer', label: t`Truck Dealer` },
  { value: 'oem', label: t`OEM` },
  { value: 'third_party_logistics', label: t`Third Party Logistics` },
];

/*
{unknown crown deka enersys c_and_d douglas bulldog exide gould varta hawker Yuasa trojan interstate us_battery}
 */
export const powerLoggerBatteryManufacturers = [
  { value: 'unknown', label: t`Unknown` },
  { value: 'crown', label: t`Crown` },
  { value: 'deka', label: t`Deka` },
  { value: 'enersys', label: t`EnerSys` },
  { value: 'c_and_d', label: t`C & D` },
  { value: 'douglas', label: t`Douglas` },
  { value: 'bulldog', label: t`Bulldog` },
  { value: 'exide', label: t`Stryten` },
  { value: 'gould', label: t`Gould` },
  { value: 'varta', label: t`Varta` },
  { value: 'hawker', label: t`Hawker` },
  { value: 'Yuasa', label: t`Yuasa` },
  { value: 'trojan', label: t`Trojan` },
  { value: 'interstate', label: t`Interstate` },
  { value: 'us_battery', label: t`US Battery` },
];
